// 存储的品牌name
export const BRAND_NAME = 'Teacher-Desk-X-BRAND';
